<div class="container" style="max-width: 100%;">
  <H1>View Direct Boxes</H1>


  <div class="row">



    <div class="col-2" style="padding-bottom: 20px;text-align: left;">

      <label> Provider Name:</label>
      <div style="display: flex;">
        <select class="form-control" name="Provider" type="text" [(ngModel)]="SearchValue.Provider" required
          placeholder=" Provider" (change)="Search()">
          <option *ngFor="let Provider of Providers; let i =index" value={{Provider}}>{{Provider}}
          </option>
        </select>
      </div>
    </div>


    <div class="col-2" style="padding-bottom: 20px;text-align: left;">

      <label> Supervisor:</label>
      <div style="display: flex;">
        <select class="form-control" name="Supervisor" type="text" [(ngModel)]="SearchValue.Supervisor" required
          placeholder=" Supervisor" (change)="Search()">
          <option *ngFor="let Supervisor of Supervisors; let i =index" value={{Supervisor}}>{{Supervisor}}
          </option>
        </select>
      </div>
    </div>

    <div class="col-2" style="padding-bottom: 20px;text-align: left;">

      <label> Agent Code: {{SearchValue.AgentName}}</label>
      <div style="display: flex;">
        <select class="form-control" name="AgentName" type="text" [(ngModel)]="SearchValue.AgentName" required
          placeholder=" AgentName" (change)="Search()">
          <option *ngFor="let Agent of Agents; let i =index" value={{Agent}}>{{Agent + AgentsName[i]}}
          </option>
        </select>
      </div>
    </div>


    <div class="col-2" style="text-align: left;">
      <label>Search Box Number:</label>
      <div class="input-group mb-3">
        <input class="form-control" ID="details" name="details" type="text" [(ngModel)]="SearchValue.Boxno"
          placeholder="Type in something to search" (ngModelChange)="Search()" />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary btnClear" type="button" id="button-addon2"
            (click)="ClearBoxNoSearch()">X</button>
        </div>
      </div>
      <div>
        <button class="btn btn-warning" type="button" id="button-addon2" (click)="ClearSearch()">Clear Search</button>
        <button class="btn btn-success" type="button" id="button-addon2" (click)="btnDownloadReportClickExcel()"
          style="margin-left: 5%;">Export</button>
      </div>
    </div>

  </div>

  <div class="row">

    <div class="col-3" style="padding-bottom: 20px;">

      <label> Connection Date:</label>
      <div class="input-group" style="margin-bottom:1rem!important;align-items: end;">
        <label>Start Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.ConnectionStartDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 2px);width:200px"
          max={{SearchValue.ConnectionEndDate}} />
      </div>

      <div class="input-group" style="align-items: end;">
        <label>End Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.ConnectionEndDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 9px);width:200px"
          min={{SearchValue.ConnectionStartDate}} />
      </div>
    </div>

    <div class="col-3" style="padding-bottom: 20px;">

      <label> Activation Date:</label>
      <div class="input-group" style="margin-bottom:1rem!important;align-items: end;">
        <label>Start Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.ActivationStartDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 2px);width:200px"
          max={{SearchValue.ActivationEndDate}} />
      </div>

      <div class="input-group" style="align-items: end;">
        <label>End Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.ActivationEndDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 9px);width:200px"
          min={{SearchValue.ActivationStartDate}} />
      </div>
    </div>

    <div class="col-3" style="padding-bottom: 20px;">

      <label>Date Issued To Agent:</label>
      <div class="input-group" style="margin-bottom:1rem!important;align-items: end;">
        <label>Start Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.DateIssuedToAgentStartDate"
          required placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 2px);width:200px"
          max={{SearchValue.DateIssuedToAgentEndDate}} />
      </div>

      <div class="input-group" style="align-items: end;">
        <label>End Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.DateIssuedToAgentEndDate" required
          placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 9px);width:200px"
          min={{SearchValue.DateIssuedToAgentStartDate}} />
      </div>
    </div>

    <div class="col-3" style="padding-bottom: 20px;">

      <label>Date Issued to supervisor:</label>
      <div class="input-group" style="margin-bottom:1rem!important;align-items: end;">
        <label>Start Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.DateAllocatedToSupervisorStartDate"
          required placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 2px);width:200px"
          max={{SearchValue.DateAllocatedToSupervisorEndDate}} />
      </div>

      <div class="input-group" style="align-items: end;">
        <label>End Date:</label>
        <input class="form-control" name="date" type="date" [(ngModel)]="SearchValue.DateAllocatedToSupervisorEndDate"
          required placeholder=" a date" (ngModelChange)="Search()" style="margin-left: calc(2.25rem + 9px);width:200px"
          min={{SearchValue.DateAllocatedToSupervisorStartDate}} />
      </div>
    </div>


  </div>




  <table class="viewDataTable" ID="tblData">
    <thead>
      <tr>
        <th class="viewDataTableHeading">Box Number</th>
        <th class="viewDataTableHeading">Brick Number</th>
        <th class="viewDataTableHeading">Serial Number</th>
        <th class="viewDataTableHeading">Provider</th>

        <th class="viewDataTableHeading">Branch</th>
        <th class="viewDataTableHeading">Supervisor</th>
        <th class="viewDataTableHeading">Agent Full Name</th>
        <th class="viewDataTableHeading">Agent Area</th>
        <th class="viewDataTableHeading">Agent Province</th>
        <th class="viewDataTableHeading">Cell Number</th>
        <th class="viewDataTableHeading">Agent Code</th>
        <th class="viewDataTableHeading">Date Issued To Supervisor</th>
        <th class="viewDataTableHeading">Date Issued To Agent</th>

        <th class="viewDataTableHeading">Connection Date</th>
        <th class="viewDataTableHeading">Activation Date</th>
        
      </tr>
    </thead>

    <tr *ngFor="let DisplayData of data | paginate: { itemsPerPage: ItemsPerPage, currentPage: p }">
      <td class="viewDataTableCell">{{DisplayData.Boxno}}</td>
      <td class="viewDataTableCell">{{DisplayData.BrickNumber}}</td>


      <td class="viewDataTableCell">{{DisplayData.Serialno}}</td>

      <td class="viewDataTableCell">{{DisplayData.Provider}}</td>

      <td class="viewDataTableCell">{{DisplayData.Branch}}</td>
      <td class="viewDataTableCell">{{DisplayData.Supervisor}}</td>
      <td class="viewDataTableCell">{{DisplayData.AgentName}}</td>
       <td class="viewDataTableCell">{{DisplayData.AgentArea}}</td>
      <td class="viewDataTableCell">{{DisplayData.AgentProvince}}</td>
      <td class="viewDataTableCell">{{DisplayData.CellNo}}</td>
      <td class="viewDataTableCell">{{DisplayData.uCode}}</td>
      <td class="viewDataTableCell">{{DisplayData.DateIssuedToSupervisor}}</td>
      <td class="viewDataTableCell">{{DisplayData.DateIssuedToAgent}}</td>
      <td class="viewDataTableCell">{{DisplayData.Connection}}</td>
      <td class="viewDataTableCell">{{DisplayData.Activation}}</td>
     
    </tr>

    <tr *ngIf="data.length <= 0">
      <td class="viewDataTableCell" colspan="15">No records found, please refine your search and try again.</td>
    </tr>

  </table>

  <pagination-controls (pageChange)="p = $event"></pagination-controls>

  <button class="btn btn-info" type="button" id="btnLoadMore" (click)="LoadMoreFields()"
    *ngIf="data.length === iRowsLoaded">Load More</button>

</div>

<!--Error popup-->
<div style="float: right;margin-left:20px;">
  <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
  </button>
</div>
<ng-template #content let-modal ID="Errormessage">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{PopupTitle}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

      <span aria-hidden="true">

      </span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="dateOfBirth">
          {{DisplayErrormessage}}
        </label>
      </div>


    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
      Done
    </button>


  </div>
</ng-template>